export const anyAuth = 'any'
export const loggedOutAuth = 'loggedOut'
export const loggedInAuth = 'loggedIn'
